import { useState, useEffect, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import headerImg from "../assets/img/HeaderImg.svg";
import { ArrowRightCircle } from "react-bootstrap-icons";
import "animate.css";
import React from "react";

export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState("");
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  const [index, setIndex] = useState(1);
  const toRotate = ["Developer", "UI/UX Designer"];
  const period = 2000;
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef();

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => {
      clearInterval(ticker);
    };
  }, [text, delta]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.1,
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [ref]);

  const tick = () => {
    console.log("Tick: ", text); // Added tick function to log the current text
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting
      ? fullText.substring(0, text.length - 1)
      : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta((prevDelta) => prevDelta / 2);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setIndex((prevIndex) => prevIndex - 1);
      setDelta(period);
    } else if (isDeleting && updatedText === "") {
      setIsDeleting(false);
      setLoopNum((loopNum + 1) % toRotate.length); // Ensure loopNum doesn't exceed the length of toRotate
      setIndex(1);
      setDelta(500);
    } else {
      setIndex((prevIndex) => prevIndex + 1);
    }
  };

  return (
    <section className="banner" id="home" ref={ref}>
      <Container>
        <Row className="aligh-items-center">
          <Col xs={12} md={6} xl={7}>
            {isVisible && (
              <div className="animate__animated animate__fadeIn">
                <span className="tagline">Welcome to My Portfolio</span>
                <h1>
                  {`Hello! I'm Eze Chinedu David, a professional`}{" "}
                  <span
                    className="txt-rotate"
                    dataPeriod="1000"
                    data-rotate='[ "Developer", "UI/UX Designer" ]'
                  >
                    <span className="wrap">{text}</span>
                  </span>
                </h1>
                <p>
                  Thank you for visiting my portfolio. I've been **passionate
                  about programming since my early years**. I find immense joy
                  in bringing my ideas to life, whether it's in a web browser or
                  through a terminal. My journey began with web development, and
                  I'm currently honing my skills in application development. I'm
                  a firm believer in lifelong learning and I constantly strive
                  to stay updated with the latest trends and technologies in the
                  digital landscape. Feel free to explore my work and don't
                  hesitate to get in touch if you'd like to collaborate on a
                  project. I'm always open to new opportunities and challenges.
                  In addition to my technical skills, I bring strong
                  problem-solving abilities, a keen eye for detail, and a
                  collaborative mindset to every project I undertake. I look
                  forward to the possibility of working together. Thank you once
                  again for your interest in my portfolio. Enjoy exploring! 😊
                </p>
                <button
                  onClick={() =>
                    window.open(
                      "https://api.whatsapp.com/send?phone=09155660116&text=Hello David!%2C%20I%27m%20interested%20in%20your%20services."
                    )
                  }
                >
                  Let’s Connect <ArrowRightCircle size={25} />
                </button>
              </div>
            )}
          </Col>
          <Col xs={12} md={6} xl={5}>
            {isVisible && (
              <div className="animate__animated animate__zoomIn">
                <img src={headerImg} alt="Header Img" />
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </section>
  );
};
